"use client";

import { GOOGLE_CLIENT_ID, isGoogleOAuthConfigured } from "@/constants";
import { GoogleOAuthProvider } from "@react-oauth/google";

/**
 * Wraps children with Google OAuth context only when a client ID is configured.
 * Missing NEXT_PUBLIC_GOOGLE_CLIENT_ID must not block email/password auth UI.
 */
export const GoogleAuthProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  if (!isGoogleOAuthConfigured() || !GOOGLE_CLIENT_ID) {
    return <>{children}</>;
  }

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      {children}
    </GoogleOAuthProvider>
  );
};
